import {DomainObject} from 'shared/store';
import {action, computed, observable} from 'mobx';
import {User} from 'stores/users';
import {timestampDate} from 'shared/tools';
import _ from 'lodash';

class ProgressUpdate extends DomainObject {
  @observable comment;
  @observable completeness;
  @observable user;
  @observable createdAt;

  @action merge(other) {
    super.merge(other, {
      user: User,
      _dates: ['createdAt']
    });
  }

  @computed get createdAtView() {
    return timestampDate(this.createdAt);
  }

  @computed get progressBarItems() {
    return [
      { label: 1, value: this.completeness, color: '#08BAD3' },
      { label: 2, value: 100 - this.completeness, color: '#EBEFF1' }
    ];
  }

  @computed get showProgressIndicator() {
    return !_.isNull(this.completeness);
  }
}

export default ProgressUpdate;
